import { useMemo } from "react";
import { Navigate, useNavigate, useParams } from "react-router";
import classNames from "classnames";
import DocumentPage from "../../../components/document-page";
import Button from "../../../components/button";
import { FaqCtaKind, getFaqCategory } from "../content";
import { openExternalUrl } from "../../../utils/telegram";
import { HelpLink, TelegramBotLink } from "../../../common/help";
import { isMobileSafari } from "../../../utils/isMobileSafari";
import styles from "./style.module.css";

function FaqCategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const category = getFaqCategory(slug);
  // Как на instruction: запас снизу под панель Safari на iPhone.
  const mobileSafariFooterPadding = useMemo(() => isMobileSafari(), []);

  if (!category) {
    return <Navigate to="/faq" replace />;
  }

  const handleCtaClick = (kind: FaqCtaKind) => {
    if (kind === "telegram") {
      openExternalUrl(TelegramBotLink);
    } else {
      navigate("/");
    }
  };

  return (
    <DocumentPage variant="scrollable">
      <h1>{category.title}</h1>

      <div className={styles.questionList}>
        {category.questions.map((item, index) => (
          <div className={styles.questionBlock} key={item.question}>
            <h2>
              {index + 1}. {item.question}
            </h2>
            <div className={styles.answer}>{item.answer}</div>
            {item.cta && (
              <div className={styles.ctaGroup}>
                {item.cta.map((cta) => (
                  <Button
                    key={cta.label}
                    label={cta.label}
                    onClick={() => handleCtaClick(cta.kind)}
                  />
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {category.note && (
        <div className={styles.noteCard}>
          <div className={styles.noteTitle}>Важно!</div>
          {category.note}
        </div>
      )}

      {/* Пустой/с кнопкой footer — как на instruction, даёт отступ над панелью Safari */}
      <div
        className={classNames(
          styles.footer,
          mobileSafariFooterPadding && styles.footerMobileSafari
        )}
      >
        {category.footerCta === "telegram" && (
          <Button label="Telegram-чат поддержки" onClick={() => openExternalUrl(HelpLink)} />
        )}
      </div>
    </DocumentPage>
  );
}

export default FaqCategoryPage;
